import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import * as myGlobals from '../../globals';
import 'rxjs/Rx';
import { ConfigService } from '../../config.service';
declare var jQuery: any;

export class User {
    constructor() { }
}

@Injectable()
export class DispatcherHomeService {

    // private _getdetUrl = myGlobals.apiurl + 'customer/bookingDetails';
    // private _cancelservice = myGlobals.apiurl + 'slave/cancelBooking';
    private _onebookingdetails = myGlobals.apiurl + 'slave/bookings';
    private _dispatcherLivepath = myGlobals.dispatchurl + 'tasks/livePath/';
    // private _cancelreasons = myGlobals.configurl + 'cancelReasons/';
    private _addcards;
    private _deletecards;
    private _getcards;

    // START OF UBER FOR ALL API CALLS
    private _getBookingHistory = myGlobals.apiurl + 'customer/bookingHistory';
    private _getdataUrl = myGlobals.apiurl + 'customer/bookingDetails';
    // private _cancelBOokingAfter = myGlobals.apiurl + 'customer/cancelBookingAfterAccept';
    private _cancelfees = myGlobals.apiurl + 'customer/cancellationFees';
    private _cancelreasons = myGlobals.apiurl + 'customer/cancellationReasonRide';
    private _cancelservice = myGlobals.apiurl + 'customer/cancelBookingAfterAccept';
    private _allbookings = myGlobals.apiurl + 'customer/bookings';
    private _bookingspath = myGlobals.apiurl + 'customer/bookingPath';

    private _ratingRide = myGlobals.apiurl + 'customer/ratingTextRide';
    private _reviewAndRating = myGlobals.apiurl + 'customer/reviewAndRating';
    private _pendingReviews = myGlobals.apiurl + 'customer/pendingReview';

    // customer/pendingReview
    // customer/favouriteDriver
    // customer/favouriteDriver
    // customer/favouriteDriver/{driverId}

    private _favoritedriver = myGlobals.apiurl + 'customer/favouriteDriver';
    private _addDropLocation = myGlobals.apiurl + 'customer/dropLocation';
    private _postTip = myGlobals.apiurl + 'customer/bookingTip';
    // END OF UBER FOR ALL API CALLS

    constructor(
        private _router: Router,
        private _http: Http,
        private _cookie: ConfigService) { }


    // START UBER FOR ALL API FUNCTIONS

    // Give Tip
    postTip (user : any) {
        let body = JSON.stringify(user);
        return this._http.post(this._postTip, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // START OF FAVORITE DRIVER APIS
    getfavdriver(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._favoritedriver, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
    postfavdriver(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._favoritedriver, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
    patchfavdriver(user: any) {
        let body = JSON.stringify(user);
        return this._http.delete(this._favoritedriver + '/' + user.driverId, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // END OF FAVORITE DRIVER APIS

    // START OF RATING APIS
    getpendingreviews(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._pendingReviews, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
    getratings(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._ratingRide, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    postreview(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._reviewAndRating, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
    // END OF RATING APIS

    getAllBooking(user: any) {
        let body = JSON.stringify(user);
        const obj = {
            status:user.status,
            fromDate: user.fromDate,
            toDate: user.toDate,
            search: user.search
        }
        return this._http.post(this._allbookings + '/' + user.type + '/' + user.limit + '/' + user.skip, obj, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    getbookingspath(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._bookingspath  + '/' +  user.bookingId, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    gethistory(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._getBookingHistory, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    getdata(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._getdataUrl + '/' + user.bookingId + '/' + user.callFrom, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    cancelfees(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._cancelfees + '/' + user.bookingId, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    cancelreasons(user: any) {
        let body = JSON.stringify(user);
        return this._http.get(this._cancelreasons, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    cancelservice(user: any) {
        let body = JSON.stringify(user);
        return this._http.put(this._cancelservice, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    addDropLocation (user : any) {
        let body = JSON.stringify(user);
        return this._http.post(this._addDropLocation, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
    // END UBER FOR ALL API FUNCTIONS


    createAuthorizationHeader(headers: Headers) {
        headers.append('authorization', sessionStorage.getItem('authtoken'));
    }

    // getdet(user: any) {
    //     let body = JSON.stringify(user);
    //     return this._http.post(this._getdetUrl, body, { headers: this._cookie.header })
    //         .map(res => res.json())
    //         .map((res) => {
    //             return res;
    //         })
    // }

    // getsingalBooking(user: any) {
    //     let body = JSON.stringify(user);
    //     return this._http.post(this._getdetUrl, body, { headers: this._cookie.header })
    //         .map(res => res.json())
    //         .map((res) => {
    //             return res;
    //         })
    // }




    // cancelservice(user: any) {
    //     let body = JSON.stringify(user);
    //     let headers = new Headers();
    //     headers.append('Content-Type', 'application/json');
    //     headers.append('authorization', sessionStorage.getItem('authtoken'));
    //     return this._http.put(this._cancelservice, body, { headers: headers })
    //         .map(res => res.json())
    //         .map((res) => {
    //             return res;
    //         })

    // }

    livePath(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        return this._http.get(this._dispatcherLivepath + user.bid, { headers: headers })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // cancelreasons(user: any) {
    //     let body = JSON.stringify(user);
    //     let headers = new Headers();
    //     return this._http.get(this._cancelreasons + user.userType + "/" + user.lang + "/" + user.bid, { headers: headers })
    //         .map(res => res.json())
    //         .map((res) => {
    //             return res;
    //         })
    // }

}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/dispatcherhome/dispatcherhome.service.ts